import * as yup from "yup";

export const inviteSchema = yup.object().shape({
    email: yup.string().email("Please enter a valid Email address").required("Field is required"),
});
